//插件api地址
//https://github.com/recurser/jquery-i18n

import * as lib from "./lib.js";
import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
var languageData = {};
var i18n = new VueI18n({
	locale: lib.getCookie("language") || navigator.language.split("-")[0],
	messages: languageData,
});
window.i18n = i18n;
if (!lib.getCookie("language") && stage.languageId) {
	//如果有配置优先语言
	lib.setCookie("language", stage.languageId);
} else {
	if ($.isNumeric(lib.getCookie("language"))) lib.setCookie("language", ""); //处理旧的方式
	stage.languageId =
		lib.getCookie("language") || navigator.language.split("-")[0];
}

// import i18n from "jquery-i18n";

// export var languageData;
// if(top==window){
// 	trace("1");
// }else trace("2");
// ={
// 	zh:{
// 		word1:"阿萨德",
// 		word2:"维尔",

// 		phrase1:"阿萨德阿萨德阿三的%s阿萨德阿萨德%s阿萨德%s"
// 	},
// 	en:{
// 		word1:"asd"
// 	}
// }

// language=$.parseJSON(language);
/*bigThen
	查找某一属性前缀中大于某数字号的属性，给予特殊字符的输出
*/
function bigThen(str, subStr, num) {
	//str:属性名 subStr:属相前缀 num:查找属性数字大于此数值的
	if (str.indexOf(subStr) >= 0) {
		var strNum = str.replace(subStr, "");
		if (strNum >= num) {
			return "*** ≥" + num + "-" + str;
		} else {
			return str;
		}
	} else {
		return str;
	}
}
function testLanguage() {
	var i,
		firstKey,
		dulLanguage = [],
		dulLanguage2 = [],
		dulKey = [];
	$.each(language, function (key, val) {
		i = 0;
		firstKey = key; //保存当前查找的属性名
		if ($.inArray(val, dulLanguage) < 0) {
			//只查找没重复过的val
			for (var searchkey in language) {
				if (language[searchkey] == val) {
					//如果当前遍历的val=外循环val

					i++;

					if (i >= 2) {
						//找到重复属性值
						if (i == 2) {
							// console.log(val);
							// console.log(bigThen(firstKey,"word",835)+":"+val);
						}
						// console.log(bigThen(searchkey,"word",835)+":"+val);
						dulLanguage2.push(val);
						// dulKey.push(searchkey);
					}

					if ($.inArray(val, dulLanguage) < 0) {
						dulLanguage.push(val);
						pubDulLanguage = dulLanguage2;
					}
				}
			} //内循环 END
		}
	}); //外循环 END
}

function getLanguageField($target) {
	//获取词条
	return $target.attr("language").split(",")[0];
}
export function setLanguage(id) {
	//设定语言
	if (!id) {
		if (!stage.languageList) {
			//根据配置生成支持的语言列表
			stage.languageList = "en,zh,pt,es,nl,pl,ko,vi"; //,fr
			// stage.languageList.push({text:getLanguageStr('lang1',['中文']),value:1});
			// stage.languageList.push({text:getLanguageStr('lang2',['English']),value:2});
		}
		if (stage.languageList.indexOf(stage.languageId) < 0)
			stage.languageId = stage.languageList.split(",")[0]; //对于不支持的语言使用第一语言
	}
	let targetId = id || stage.languageId;
	stage.languageId = targetId;
	lib.setCookie("language", targetId);
	if (id) location.reload();
	else {
		i18n.locale = stage.languageId;
		loadLanguage();
	}
	// if(languageData[stage.languageId]==undefined){
	// 	loadLanguage();
	// }
	if ($.type(stage.languageList) == "string") {
		//string类型是初始配置值，需要根据此值进行二次配置
		let codeList = stage.languageList.split(",");
		stage.languageList = [];
		codeList.map((code) => {
			let newLan = [];
			switch (code) {
				case "zh":
					newLan = [getLanguageStr("lang1", "中文"), code];
					break;
				case "en":
					newLan = [getLanguageStr("lang2", "English"), code];
					break;
				case "pt":
					newLan = [getLanguageStr("lang3", "葡萄牙语"), code];
					break;
				case "pl":
					newLan = [getLanguageStr("lang4", "波兰语"), code];
					break;
				case "es":
					newLan = [getLanguageStr("lang5", "西班牙语"), code];
					break;
				case "nl":
					newLan = [getLanguageStr("lang6", "荷兰语"), code];
					break;
				case "fr":
					newLan = [getLanguageStr("lang7", "法语"), code];
					break;
				case "ko":
					newLan = [getLanguageStr("me21", "韩语"), code];
					break;
				case "vi":
					newLan = [getLanguageStr("me22", "越南语"), code];
					break;
				// case "":newLan=[getLanguageStr('lang',''),];break;
			}
			stage.languageList.push({ text: newLan[0], value: newLan[1] });
		});
	}
}
export function getLanguageType(id = stage.languageId) {
	var str = "";
	switch (Number(id)) {
		case 1:
			str = "zh";
			break;
		case 2:
			str = "en";
			break;
		case 3:
			str = "pt";
			break;
		case 4:
			str = "pl";
			break;
		case 5:
			str = "es";
			break;
		case 6:
			str = "nl";
			break;
		case 7:
			str = "fr";
			break;
		case 8:
			str = "ko";
			break;
		case 9:
			str = "vi";
			break;
		default:
			str = "en";
			break;
	}
	return str;
}
export function displayLanguage(id) {
	//通过语言id输出最终语言
	let out = "";
	switch (id) {
		case "zh":
			out = getLanguageStr("lang1", "中文");
			break;
		case "en":
			out = getLanguageStr("lang2", "English");
			break;
		case "pt":
			out = getLanguageStr("lang3", "Português");
			break;
		case "pl":
			out = getLanguageStr("lang4", "Polski");
			break;
		case "es":
			out = getLanguageStr("lang5", "Español");
			break;
		case "nl":
			out = getLanguageStr("lang6", "De Nederlandse");
			break;
		case "fr":
			out = getLanguageStr("lang7", "Français");
			break;
		case "ko":
			out = getLanguageStr("me21", "韩语");
			break;
		case "vi":
			out = getLanguageStr("me22", "越南语");
			break;
	}
	return out;
}
// function getLanguageId(type){
// 	type=type.split("-")[0];
// 	var id=0;
// 	switch(type){
// 		case "zh":
// 		case "zh-CN":
// 		case "zh-HK":
// 		case "zh-TW":
// 		case "zh_CN":id=1;break;
// 		case "en-GB":
// 		case "en-US":
// 		case "en_US":id=2;break;
// 		case "pt":
// 		case "pt-PT":
// 		case "pt-BR":id=3;break;
// 		case "pl":id=4;break;
// 		case "es":id=5;break;
// 		case "nl":id=6;break;
// 		case "fr":id=7;break;
// 		default:id=2;break;
// 	}
// 	return id;
// }
// function getLanguage($root,mode){
// 	if($.type($root)=="string") $root=$($root);
// 	function tra($target,targetMode){
// 		if(targetMode=="src"){
// 			if($target.attr("language-src")){
// 				var file=$target.attr("language-src").split(".");
// 				file[file.length-2]+="-"+getLanguageType(languageId||stage.languageId);
// 				$target.attr("src",file.join("."));
// 			}
// 		}else{
// 			var out="";
// 			if(targetMode==undefined||targetMode=="language"){//直接填充翻译的内容
// 				if($target.attr("language")){
// 					var languageVal=$target.attr("language");
// 					if(languageVal.split(",")[0].indexOf("fill") >= 0) {
// 						var params = languageVal.replace(languageVal.split(",")[0]+',',"");
// 						out=getLanguageFill(languageVal.split(",")[0],params);
// 						$target.html(out);
// 					}else{
// 						out=getLanguageStr($target.attr("language").split(",")[0]);
// 						$target.html(out);
// 						// if(out==$target.attr("language").split(",")[0]) trace($target.attr("language"));
// 					}
// 				}
// 			}else{//给属性填充翻译后的内容
// 				if($target.attr("language-"+targetMode)){
// 					out=($target.attr("language-"+targetMode).split(",")[0]=="language")? $target.attr("language").split(",")[0]:$target.attr("language-"+targetMode).split(",")[0];

// 					var languageTargetModeVal=$target.attr("language-"+targetMode);
// 					if (out.indexOf("fill") >= 0) {
// 						var paramsAttr=($target.attr("language-"+targetMode).split(",")[0]=="language")? $target.attr("language"):$target.attr("language-"+targetMode);
// 						var params_languageTargetMode = paramsAttr.replace(paramsAttr.split(",")[0]+',',"");
// 						out=getLanguageFill(out,params_languageTargetMode);
// 					}else {
// 						out=getLanguageStr(out);
// 					}

// 					$target.attr(targetMode,out);
// 					// if(out==$target.attr("language-"+targetMode).split(",")[0]) trace($target.attr("language-"+targetMode));
// 				}
// 			}
// 		}//end if
// 		// trace(out)
// 	}
// 	function each($each,targetMode){
// 		$each.each(function(){
// 			tra($(this),targetMode);
// 		});
// 		// tra($each.eq(0),targetMode);//自己也翻译下
// 	}
// 	if($root&&!mode){
// 		each($root);
// 		each($root.find("[language]"));
// 		each($root,"title");
// 		each($root.find("[language-title]"),"title");
// 		each($root,"placeholder");
// 		each($root.find("[language-placeholder]"),"placeholder");
// 		each($root,"src");
// 		each($root.find("[language-src]"),"src");
// 	}else if($root&&mode){
// 		each($root,mode);
// 		each($root.find("[language-"+mode+"]"),mode);
// 		each($root,"src");
// 		each($root.find("[language-src]"),"src");
// 	}else{
// 		each($("[language]"));
// 		each($("[language-title]"),"title");
// 		each($("[language-placeholder]"),"placeholder");
// 		each($("[language-src]"),"src");
// 	}
// }
export function getLanguageStr(fullStr, reference) {
	//翻译内容并带拼接功能
	function loopDo(text, listStr, targetText) {
		$.each(listStr.split(","), (index, value) => {
			if (text.indexOf(value) >= 0) {
				text = text.replace(new RegExp(value, "g"), targetText); //.toLowerCase()
			}
		});
		return text;
	}
	function oemText(text) {
		//自动检测并替换oem文本词条
		// if(location.hostname!="pro.solarman.cn"&&location.hostname!="btest.solarman.cn"&&location.hostname!="home.solarman.cn"){
		// 	switch(textId){
		// 		case "phrase234":textId="phrase499";break;
		// 		case "phrase235":textId="phrase500";break;
		// 		case "phrase236":textId="phrase501";break;
		// 		case "word835":textId="word1125";break;//小麦号
		// 		// case "":textId="";break;
		// 		// case "":textId="";break;

		// 		// case "":textId="";break;
		// 	}
		// }
		switch (stage.loc.customer) {
			case "Bliq":
				if (stage.languageId == "nl")
					text = loopDo(text, "Logger,logger", "Bliq-vanger");
				break;
		}
		return text;
	}

	var out = "",
		error = false;
	$((fullStr || "").split("+")).each(function (index, text) {
		var tran = oemText(i18n.t(text));
		out += stage.languageId != "zh" && index > 0 ? " " + tran : tran; //非中文情况下下一个单词需要加空格
		if ((tran == text || !tran) && text.match(/[a-z0-9]/)) error = true; //特殊字符不检测
		// else error=false;
	});
	// $(fullStr.split("")).each(function(){//跳过带特殊字符的拼接
	// 	if(!this.match(/[a-z0-9]/)){
	// 		error=false;
	// 		return;
	// 	}
	// });
	if (error) {
		let toUse = lib.objTool(
			languageData[stage.languageId],
			"findByValue",
			reference
		);
		console.log(fullStr + "-" + reference, "可以转用：" + toUse); //输出未找到的词条
	}
	// return out=="%"? out:decodeURIComponent(out);
	return out;
}
window.getLanguageStr = getLanguageStr;

function getLanguageFill(fullStr, params) {
	//翻译fill内容并带拼接功能
	//language="fill18+fill69,get=word204,词1填充2,词1填充3,在“电站”中搜索+get=word201|888
	//language="译词1 +译词2 ,译词1填充序列(,分隔)         ,备注          +,译词2填充序列(|分隔)"
	var out = "",
		error = false,
		fillSplitStr = ",";
	var paramsLast = params.split(",").pop(); //抽出,分割数组中最后一个
	$(fullStr.split("+")).each(function (index) {
		//拼接遍历
		if (this.substring(0, 4) == "fill") {
			var arr = [];
			if (index > 0) {
				//如果第n拼接词也是fill，则把paramsLast + 分割数组的第n个元素作为填充组
				fillSplitStr = "|";
				params = paramsLast.split("+")[index]; //paramsLast + 分割数组的第n个元素
			}
			if (params) {
				$(params.split(fillSplitStr)).each(function () {
					if (this.split("=").length > 1) {
						arr.push(getLanguageStr(this.split("=")[1]));
					} else {
						arr.push(this);
					}
				});
				var tran = $.i18n._(
					this,
					arr[0] || "",
					arr[1] || "",
					arr[2] || "",
					arr[3] || "",
					arr[4] || ""
				);
			} else {
				var tran = this;
				trace(fullStr.split("+")[index] + " 没找到填充组");
			}

			if ((tran == this || tran == "") && this.match(/[a-z0-9]/))
				error = true; //特殊字符不检测
		} else {
			var tran = getLanguageStr(this);
		}

		out += stage.languageId != 1 && index > 0 ? " " + tran : tran; //非中文情况下下一个单词需要加空格
	});
	if (error) trace(fullStr); //输出未找到的词条
	return out;
}

// import "./zh.json";
// let languageData={
// zh:require("./zh.json"),
// en:require("./en.json"),
// pt:require("./pt.json"),
// pl:require("./pl.json")
// }
function loadLanguage() {
	//加载语言文件
	// var languageFile="/"+stage.path+stage.pathEX+"js/i18n/"+getLanguageType(stage.languageId)+".js?v="+stage.ver;
	var languageFile = `${stage.loc.baseRouter}static/i18n/${stage.languageId}.js?v=${stage.ver}`;
	$.ajax(languageFile, {
		type: "GET",
		async: false,
		dataType: "text",
		// complete:function(data){
		// },
		cache: true,
		success: function (data) {
			// console.log( data )
			data = $.parseJSON(data);
			//成品词条替换
			switch (stage.loc.customer) {
				case "CSICloud":
					// data.word738 = data.CSICloud2; //家用屋顶
					// data.creat_plant12 = data.CSICloud2; //家用屋顶
					// data.word739 = data.CSICloud3; //分布式商业
					// data.creat_plant13 = data.CSICloud3; //分布式商业
					// data.word740 = data.CSICloud4; //分布式工业
					// data.creat_plant14 = data.CSICloud4; //分布式工业
					// data.word741 = data.CSICloud5; //光分布式全额上网
					// data.creat_plant15 = data.CSICloud5; //分布式全额上网
					// data.word742 = data.CSICloud6; //分布式自发自用余电上网
					// data.creat_plant16 = data.CSICloud6; //分布式自发自用余电上网
					// data.word308 = data.CSICloud7; //储能系统
					// data.plant_detail284 = data.CSICloud7; //储能系统
					break;
			}
			if (stage.languageEmptyToken) {
				//给空词条填充
				$.each(data, (key, value) => {
					if (value == "") data[key] = stage.languageEmptyToken;
				});
			}
			languageData[stage.languageId] = data;
			// languageData=$.parseJSON(data);
			// $.i18n.load($.parseJSON(data));
			// testLanguage();
		},
	});
	// var languageData=require(["./"+getLanguageType(stage.languageId)+".json"],resolve);
}
// if(language){
// 	$.i18n.load(language);
// }else{
// 	loadLanguage();
// }
// loadLanguage();
setLanguage();
// console.log(i18n)
// setTimeout(function(){setLanguage(1);},2000)
// $(function(){
// getLanguage();
// $.i18n.load(language[getLanguageType($("body").attr("languageId"))],function(){alert("asd")});
// $("[asd]")._t( getLanguageField($("[asd]")),"asd","123","1asd" );
// });

export default i18n;



// WEBPACK FOOTER //
// ./src/util/language.js